import { UIText1 } from '@cian/ui-kit';
import { plural } from '@cian/utils/lib/shared/plural';
import * as React from 'react';

import * as styles from './styles.css';

type TChatUnreadMessagesButton = {
  counter: number;
  onClick: () => void;
};

export const ChatUnreadMessagesButton: React.FC<TChatUnreadMessagesButton> = ({ counter, onClick }) => {
  return (
    <button className={styles['container']} type="button" onClick={onClick}>
      <UIText1 color="text-inverted-default" fontWeight="700">
        {counter} {plural(counter, ['новое сообщение', 'новых сообщения', 'новых сообщений'])}
      </UIText1>
    </button>
  );
};
